import Quill from 'quill/core';
import CodeEmbedEditorClipboard from './CodeEmbedClipboard';
import CodeEmbedEditorKeyboard from './CodeEmbedEditorKeyboard';
import ChildHistory from '../utils/ChildHistory';

const Theme = Quill.import('core/theme');

// @ts-expect-error
class CodeEmbedEditorTheme extends Theme {
  declare quill: Quill;

  addModule(name: string) {
    if (name === 'keyboard') {
      const keyboard = new CodeEmbedEditorKeyboard(
        this.quill,
        // @ts-expect-error
        this.options.modules[name] || {},
      );
      // @ts-expect-error
      this.modules[name] = keyboard;
      return keyboard;
    }
    if (name === 'history') {
      const history = new ChildHistory(this.quill, {
        // @ts-expect-error
        parentQuill: this.options.modules.history.parentQuill,
      });
      // @ts-expect-error
      this.modules[name] = history;
      return history;
    }
    if (name === 'clipboard') {
      const clipboard = new CodeEmbedEditorClipboard(this.quill, {
        // @ts-expect-error
        blot: this.options.modules.clipboard.blot,
      });
      // @ts-expect-error
      this.modules[name] = clipboard;
      return clipboard;
    }

    return super.addModule(name);
  }
}

export default CodeEmbedEditorTheme;
